var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#93989D",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49 8.6a.52.52 0 00-.3-.1c-.97 0-1.8.71-1.93 1.67l-.43 2.54A2 2 0 004.82 15h6.36a2 2 0 001.99-2.3l-.43-2.53a1.95 1.95 0 00-1.93-1.67c-.1 0-.21.04-.3.1a4.37 4.37 0 01-5.02 0zm6.01-4.1a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalAccount);
export default __webpack_public_path__ + "static/media/personal-account.657ad306056222f10f3e934d0da0668f.svg";
export { ForwardRef as ReactComponent };